// extracted by mini-css-extract-plugin
export var compactFilters = "_f3-4";
export var detailImage = "_f3-1";
export var dropdownContainer = "_f3-2";
export var imageContainer = "_f3-0";
export var selectedCard = "_f3-3";